import React, { useState } from 'react';
import {
    Button,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Autocomplete,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Card,
    Chip
  } from '@mui/material';

const ProcessProduct = ( {orderProduct, selectedProductLocations, setSelectedProductLocations}) => {

    const [barCodes, setBarCodes] = useState({});

    const handleBarCodeChange = (event, slotId, productIndex) => {
        const updatedBarCodes = {...barCodes};
        const updatedSelectedProductLocations = {...selectedProductLocations};
        updatedBarCodes[slotId] = updatedBarCodes[slotId] || {};
        updatedBarCodes[slotId][productIndex] = updatedBarCodes[slotId][productIndex] || {};
        updatedBarCodes[slotId][productIndex]["code"] = event.target.value;
        if (updatedBarCodes[slotId][productIndex]["verified"]){
            updatedSelectedProductLocations[orderProduct.product.id].slots[slotId].verified -= 1;
        }
        updatedBarCodes[slotId][productIndex]["verified"] = false;
        setBarCodes(updatedBarCodes);
        setSelectedProductLocations(updatedSelectedProductLocations);
    }


    const checkBarCode = (slotId, productIndex) => () => {
        const updatedBarCodes = {...barCodes};
        const updatedSelectedProductLocations = {...selectedProductLocations};
        if ((updatedBarCodes[slotId]?.[productIndex]?.["code"] === orderProduct.product.barcode) || (updatedBarCodes[slotId]?.[productIndex]?.["code"] === orderProduct.product.sku)) {
            updatedBarCodes[slotId][productIndex]["verified"] = true;
            updatedSelectedProductLocations[orderProduct.product.id].slots[slotId].verified += 1;
        }
        setBarCodes(updatedBarCodes);
        setSelectedProductLocations(updatedSelectedProductLocations);
    }

    const isAvailable = orderProduct.quantity <= selectedProductLocations[orderProduct.product.id].total_stock;
    const chipLabel = isAvailable ? 'Disponible' : 'No disponible';
    const chipClassName = isAvailable ? "processable-chip" : "unprocessable-chip";


    const handleLocationQuantityChange = (event, slotId) => {
        const parsedValue = parseInt(event.target.value)
        const maxQuantity = Math.min(selectedProductLocations[orderProduct.product.id].slots[slotId].quantity, orderProduct.quantity - selectedProductLocations[orderProduct.product.id].total_assigned + selectedProductLocations[orderProduct.product.id].slots[slotId].assigned);
        if (isNaN(parsedValue) || parsedValue < 0 || parsedValue > maxQuantity) {
            return;
        }
        const updatedSelectedProductLocations = {...selectedProductLocations};
        const updatedBarCodes = {...barCodes};
        updatedSelectedProductLocations[orderProduct.product.id].slots[slotId].assigned = parsedValue;
        updatedSelectedProductLocations[orderProduct.product.id].total_assigned = Object.values(updatedSelectedProductLocations[orderProduct.product.id].slots).reduce((acc, slot) => acc + slot.assigned, 0);

        for (const productIndex in updatedBarCodes[slotId]) {
            if (productIndex >= parsedValue) {
                if (updatedBarCodes[slotId][productIndex]["verified"]) {
                    updatedSelectedProductLocations[orderProduct.product.id].slots[slotId].verified -= 1;
                }
                delete updatedBarCodes[slotId][productIndex];
            }
        }
        setBarCodes(updatedBarCodes);
        setSelectedProductLocations(updatedSelectedProductLocations);
        }




    return (
    <Grid item xs={12} key={orderProduct.product.id}>
        <Card variant="outlined">
        <ListItem>
            <ListItemText primary={orderProduct.product.name} secondary={`SKU: ${orderProduct.product.sku}`} />
            <Typography>{"x " + orderProduct.quantity}</Typography>
            <Chip
            variant="contained"
            label={chipLabel}
            className={chipClassName}
            style={{ marginLeft: '15px' }}
            />
        </ListItem>
        
        <ListItem>
            <ListItemText primary="Ubicaciones:"/>
        </ListItem>
        <div className='product-list-container'>
            <List >
              {Object.entries(selectedProductLocations[orderProduct.product.id].slots).map(([id, slot], index) => {
                const maxQuantity = Math.min(slot.quantity, orderProduct.quantity - selectedProductLocations[orderProduct.product.id].total_assigned + slot.assigned);
                if (slot.quantity > 0) {
                return (
                    <>
                    <Divider variant="middle"/>
                
                <ListItem key={index}>
                    <ListItemText primary={slot.name} secondary={`Stock: ${slot.quantity}` } />
                    <ListItemSecondaryAction>
                    <TextField
                        label="Cantidad"
                        type="number"
                        value={slot.assigned}
                        onChange={(event) => handleLocationQuantityChange(event, id)}
                        inputProps={{
                        min: 0,
                        step: 1,
                        max: maxQuantity
                        }}
                    />
                    {(slot.assigned === slot.verified) ? (
                    <Button edge="end" disabled>
                        <i className="material-icons-outlined valid-icon">check_circle</i>
                    </Button>
                     ) : (
                    <Button edge="end" disabled>
                        <i className="material-icons-outlined invalid-icon">cancel</i>
                    </Button>
                    )}
                    </ListItemSecondaryAction>
                </ListItem>
                {Array.from({ length: slot.assigned }, (_, productIndex) => (
                    <ListItem key={index} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography>{orderProduct.product.sku}</Typography>
                        <TextField
                        value={barCodes[id]? barCodes[id][productIndex] ? barCodes[id][productIndex]["code"] : "" : ""}
                        onChange={(event) => handleBarCodeChange(event, id, productIndex)}
                        label="Código de barras"
                        style={{ marginLeft: '30px'}}
                        />
                        <div>
                            <Button onClick={checkBarCode(id, productIndex)} >
                                <i className="material-icons-outlined check-button">autorenew</i>
                            </Button>
                                {barCodes[id]?.[productIndex]?.verified ? (
                                <Button edge="end" disabled>
                                    <i className="material-icons-outlined valid-icon">check_circle</i>
                                </Button>
                                ) : (
                                <Button edge="end" disabled>
                                    <i className="material-icons-outlined invalid-icon">cancel</i>
                                </Button>
                             )}
                        </div>
                    </ListItem>
                    ))}
                </>
                

                )}})}
            </List>
            </div>
        </Card>
    </Grid>
    );
}

export default ProcessProduct;